import { createFeatureSelector } from '@ngrx/store';

import { MODULE_KEY } from '../../constants';
import { TransactionRegisterState } from '../reducers/transaction-register.reducer';

export const transactionRegisterFeatureSelector = createFeatureSelector<TransactionRegisterState>(MODULE_KEY);
